import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVolumeoff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.25 20.37c0 1.085-1.29 1.655-2.092.924l-4.476-4.078a.25.25 0 0 0-.17-.065H4a1.75 1.75 0 0 1-1.75-1.75v-6.8c0-.967.784-1.75 1.75-1.75h2.513a.25.25 0 0 0 .169-.065l4.476-4.078c.803-.73 2.092-.16 2.092.925zM3.75 15.4c0 .138.112.25.25.25h2.513c.436 0 .856.163 1.178.457l4.059 3.696V4.197L7.691 7.895a1.75 1.75 0 0 1-1.178.456H4a.25.25 0 0 0-.25.25zM21.47 8.47a.75.75 0 1 1 1.06 1.061l-2.47 2.47 2.47 2.47a.75.75 0 1 1-1.06 1.06L19 13.061l-2.47 2.47a.75.75 0 1 1-1.06-1.06L17.94 12l-2.47-2.47a.75.75 0 1 1 1.06-1.06L19 10.94z"
  }));
}
var IcVolumeoff = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeoff));

export { IcVolumeoff as I };
